<template>
  <div class="offline-message">
    <p>Olá! Sentimos muito, mas o WhatsApp lançou uma atualização e por conta disso as integrações estão fora do ar.</p>
    <p>Nosso time de desenvolvimento já está trabalhando para regularizar.</p>
    <p>Em breve estará pronto para o uso.</p>
  </div>
</template>
<script>
  export default {
    name: 'whatsapp-offline',
    data() {
      return {
      }
    }
  }
</script>